import { render, staticRenderFns } from "./v2_manual_create_details.vue?vue&type=template&id=546b82c7&scoped=true&"
import script from "./v2_manual_create_details.vue?vue&type=script&lang=js&"
export * from "./v2_manual_create_details.vue?vue&type=script&lang=js&"
import style0 from "./v2_manual_create_details.vue?vue&type=style&index=0&id=546b82c7&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b82c7",
  null
  
)

export default component.exports